import * as React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

type requestFormProps = {
    text: string,
    showModal: boolean,
    setShowModal: (show: boolean) => void,

};

export const Modal = ({
                          text,
                          showModal,
                          setShowModal
                      }: requestFormProps) => {

    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="modal-title-style"
                open={showModal}
                maxWidth={'md'}
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="modal-title-style">Atliekų aprašymas</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    {text}
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
